var _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTariff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16667 9.33333H8.16667C8.81183 9.33333 9.33333 8.81067 9.33333 8.16667V1.16667C9.33333 0.522667 8.81183 0 8.16667 0H1.16667C0.5215 0 0 0.522667 0 1.16667V8.16667C0 8.81067 0.5215 9.33333 1.16667 9.33333ZM2.33338 2.33338H7.00005V7.00005H2.33338V2.33338ZM19.8334 0H12.8334C12.1882 0 11.6667 0.522667 11.6667 1.16667V8.16667C11.6667 8.81067 12.1882 9.33333 12.8334 9.33333H19.8334C20.4785 9.33333 21 8.81067 21 8.16667V1.16667C21 0.522667 20.4785 0 19.8334 0ZM18.6667 7.00005H14.0001V2.33338H18.6667V7.00005ZM8.16667 21C8.81183 21 9.33333 20.4785 9.33333 19.8334V12.8334C9.33333 12.1882 8.81183 11.6667 8.16667 11.6667H1.16667C0.5215 11.6667 0 12.1882 0 12.8334V19.8334C0 20.4785 0.5215 21 1.16667 21H8.16667ZM2.33338 14.0001H7.00005V18.6667H2.33338V14.0001ZM17.5 12.8334H15.1667V15.1667H12.8334V17.5H15.1667V19.8334H17.5V17.5H19.8334V15.1667H17.5V12.8334Z",
    fill: "url(#paint0_linear_765_7463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16667 9.33333H8.16667C8.81183 9.33333 9.33333 8.81067 9.33333 8.16667V1.16667C9.33333 0.522667 8.81183 0 8.16667 0H1.16667C0.5215 0 0 0.522667 0 1.16667V8.16667C0 8.81067 0.5215 9.33333 1.16667 9.33333ZM2.33338 2.33338H7.00005V7.00005H2.33338V2.33338ZM19.8334 0H12.8334C12.1882 0 11.6667 0.522667 11.6667 1.16667V8.16667C11.6667 8.81067 12.1882 9.33333 12.8334 9.33333H19.8334C20.4785 9.33333 21 8.81067 21 8.16667V1.16667C21 0.522667 20.4785 0 19.8334 0ZM18.6667 7.00005H14.0001V2.33338H18.6667V7.00005ZM8.16667 21C8.81183 21 9.33333 20.4785 9.33333 19.8334V12.8334C9.33333 12.1882 8.81183 11.6667 8.16667 11.6667H1.16667C0.5215 11.6667 0 12.1882 0 12.8334V19.8334C0 20.4785 0.5215 21 1.16667 21H8.16667ZM2.33338 14.0001H7.00005V18.6667H2.33338V14.0001ZM17.5 12.8334H15.1667V15.1667H12.8334V17.5H15.1667V19.8334H17.5V17.5H19.8334V15.1667H17.5V12.8334Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_765_7463",
    x1: 0,
    y1: 10.7561,
    x2: 21,
    y2: 10.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FDDF5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariff);
export default __webpack_public_path__ + "static/media/tariff.68e6a8606e7d8e7ed84a98db1a2a6e97.svg";
export { ForwardRef as ReactComponent };